import Marquee from "react-fast-marquee";
import { Reveal, Overline } from "./Reveal";
import { QUICK } from "../../lib/data";

const MANIFEST = [
  { n: "01", t: "Profesional", d: "Layanan dan penanganan yang rapi, jujur, serta mengedepankan kebutuhan pelanggan." },
  { n: "02", t: "Sesuai Kebutuhan", d: "Solusi disusun berdasarkan kondisi rumah, toko, kantor, maupun bisnis Anda." },
  { n: "03", t: "Produk + Instalasi", d: "Menyediakan perangkat sekaligus layanan pemasangan dari satu tempat." },
];

export const Overview = () => (
  <>
    {/* Quick info */}
    <section className="relative z-10 -mt-16 md:-mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {QUICK.map((q, i) => (
            <Reveal key={q.title} delay={i * 0.08}>
              <div
                data-testid={`quick-info-${i}`}
                className="h-full rounded-2xl bg-white border border-gray-100 shadow-xl shadow-[#071A33]/5 p-6 hover:-translate-y-1.5 hover:shadow-2xl transition-all duration-300"
              >
                <span className="grid place-items-center h-12 w-12 rounded-xl bg-[#F5F7FA] text-[#0B63F6]">
                  <q.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-4 font-heading font-bold text-[#111827] text-lg">{q.title}</h3>
                <p className="mt-1.5 text-sm text-[#6B7280] leading-relaxed">{q.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    {/* About / Manifesto */}
    <section id="tentang" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal><Overline>Tentang Kami</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading font-bold text-[#111827] text-4xl md:text-5xl tracking-tight leading-tight">
              Partner Teknologi untuk Kebutuhan Anda
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-[#6B7280] text-base md:text-lg leading-relaxed">
              SATCOM MEDIA TEKNOLOGI hadir untuk membantu kebutuhan teknologi, keamanan,
              konektivitas, dan perangkat digital bagi pelanggan di Rangkasbitung dan
              wilayah sekitarnya.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-4 text-[#6B7280] text-base md:text-lg leading-relaxed">
              Kami menyediakan produk sekaligus layanan pemasangan sehingga pelanggan
              dapat memperoleh solusi yang lebih praktis dari satu tempat.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 space-y-4">
          {MANIFEST.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.1}>
              <div className="group flex gap-6 rounded-2xl border border-gray-100 bg-[#F5F7FA]/60 p-7 hover:bg-white hover:shadow-xl hover:shadow-[#071A33]/5 transition-all duration-300">
                <span className="font-heading font-extrabold text-4xl md:text-5xl bg-gradient-to-b from-[#0B63F6] to-[#16C7E8] bg-clip-text text-transparent">
                  {m.n}
                </span>
                <div>
                  <h3 className="font-heading font-bold text-xl text-[#111827]">{m.t}</h3>
                  <p className="mt-1.5 text-[#6B7280] leading-relaxed">{m.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-20 border-y border-gray-100 py-6 select-none">
        <Marquee speed={45} gradient={false} autoFill>
          {["CCTV", "PARABOLA", "WIFI & JARINGAN", "HARDWARE", "SOFTWARE", "KONSULTASI"].map((w) => (
            <span
              key={w}
              className="mx-8 font-heading font-extrabold text-4xl md:text-6xl text-transparent"
              style={{ WebkitTextStroke: "1px #D8DEE9" }}
            >
              {w} <span className="text-[#16C7E8]" style={{ WebkitTextStroke: "0" }}>✦</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  </>
);
